module.exports = __webpack_public_path__ + "1f0436695e1002d4af247c8b10280c04.eot";


//////////////////
// WEBPACK FOOTER
// ./src/font/31E6D3_1_0.eot
// module id = 844
// module chunks = 2